<div class="p-grid p-fluid">
  <p-panel
    *ngIf="autocolor"
    class="p-col-12 p-md-12"
  >
    <ng-template pTemplate="header">
      <b>
        {{ autocolor.nombre }} - {{ autocolor.fabricante.nombre }} :
        {{ autocolor.codigo }}</b
      >
    </ng-template>

    <div class="p-fluid p-grid">
      <div class="p-field p-col-4 p-md-3 m-0 py-0">
        <p><b> Formula:</b> {{ formula?.pk.id }}</p>
      </div> 
      <div class="p-field p-col-4 p-md-3 m-0 py-0">
        <p><b> Sistema:</b> {{ formulacolor?.formula.sistema?.nombre }}</p>
      </div>
      <div class="p-field p-col-4 p-md-3 m-0 py-0">
        <p><b> Tipo:</b> {{ formulacolor?.tipo?.nombre }}</p>
      </div>

      <div class="p-field p-col-4 p-md-3 m-0 py-0">
        <p><b> Deck/Chip:</b> {{ formula?.chip }}</p>
      </div>
      <!--    <div class="p-field p-col-6 p-md-3 m-0 py-0">
        <p><b> GSU #:</b> {{ formula?.gsu }}</p>
      </div>
      <div class="p-field p-col-6 p-md-3 m-0 py-0">
        <b> Creada:</b> {{ formula?.fechacrea | date: "dd/MM/yyyy" }}
      </div> -->
    </div>
  </p-panel>
</div>

<div><p-progressSpinner *ngIf="isLoading"></p-progressSpinner></div>

<div *ngIf="formulacolor && !subformulas?.length">
  <formula-child
    [formulaChild]="formulacolor?.formula"
    [formulaColor]="formulacolor"
    [tipo]="formulacolor.tipo"
    class="p-col-12 p-md-10"
  >
  </formula-child>
</div>

<div *ngIf="subformulas?.length">
  <formula-child
    *ngFor="let sub of subformulas"
    [formulaChild]="sub.formula"
    [formulaColor]="formulacolor"
    [tipo]="sub.tipo"
    class="p-col-12 p-md-10"
  >
  </formula-child>
</div>

<div class="p-col-12" *ngIf="!isLoading">
  <button
    pButton
    type="button"
    label="Imprimir"
    class="p-button-raised"
    icon="pi pi-print"
    iconPos="right"
    (click)="imprimirFormula()"
  ></button>
</div>
